import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import InnerLoading from '../ui/InnerLoading'
import { CiLocationOn } from 'react-icons/ci'
import { FaCalendarAlt, FaStar } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { getStatusClass } from '../../utils/data'
import { fetchBookHalls } from '../../features/home/bookingSlice'


const BookedHalls = () => {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const { bookedHalls, loading } = useSelector((state: RootState) => state.bookingSlice)
    const { user } = useSelector((state: RootState) => state.user)

    useEffect(() => {
        if (user?.id) {
            dispatch(fetchBookHalls(user.id))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, user?.id])



    return (
        <>
        <h3 className='text-2xl font-semibold mb-4'>{t("my-bookings")}</h3>
            {loading ? (
                <InnerLoading />
            ) : bookedHalls.length === 0 ? (
                <div className="flex-center flex-col gap-3">
                    <div className="w-52">
                        <img
                            src="/asset/no-books.png"
                            className="w-full"
                            alt="no-books"
                            loading="lazy"
                        />
                    </div>
                    <p className="text-textSecond">{t('no-halls')}</p>
                </div>
            ) : (
                <div className="grid gap-4 xs:grid-cols-1 md:grid-cols-2">
                    {bookedHalls.map((hall, idx) => (
                        <Link
                            to={`/me/hall-book-details/${hall.id}`}
                            key={idx}
                            className="flex w-full overflow-hidden rounded-2xl border shadow-sm bg-white"
                        >
                            <div className="relative xs:w-32 sm:w-40 overflow-hidden">
                                <img
                                    src={hall?.place?.images?.[0]?.url||"/asset/modern-commercial-building.webp"}
                                    alt={hall?.place?.title}
                                    className="w-full h-full object-cover"
                                />
                                <span
                                    className={`absolute top-3 ${i18n.language === 'ar' ? 'right-3' : 'left-3'
                                        } rounded-md bg-primary px-3 py-1 text-xs sm:text-sm text-white`}
                                >
                                    {hall?.place?.subCategory?.title || hall?.place?.type}
                                </span>
                            </div>
                            <div className="flex flex-col justify-between flex-1 p-3">
                                <div className="border-b pb-2">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2 text-sm text-gray-600">
                                            <FaStar className="text-secondry" />
                                            {hall?.place?.rate?.toFixed(1)}{' '}
                                            <span className="text-gray-400">
                                                ({hall?.place?.reviews?.length} {t('reviews')})
                                            </span>
                                        </div>
                                        <span
                                            className={`xs:text-xs sm:text-sm font-medium ${getStatusClass(
                                                hall.state
                                            )}`}
                                        >
                                            {hall?.state==="Pending"&&hall.paymentMethod==="Cash"?t("pending-cash") : t(`${hall?.state.toLowerCase()}`) || hall?.state}
                                        </span>
                                    </div>
                                    <h2 className="mt-1 text-lg font-bold">
                                        {hall?.place?.title}
                                    </h2>
                                    <p className="flex items-center gap-1 text-sm text-gray-500">
                                        <CiLocationOn /> {hall?.place?.location}
                                    </p>
                                    <p className="mt-1 text-lg font-semibold text-secondry">
                                        {hall?.price.toFixed(2)} {user?.currencyCode}
                                    </p>
                                </div>
                                <div className="flex-between pt-2 text-sm text-textSecond">
                                    <p className="flex items-center gap-1 text-darkColor font-medium">
                                        <FaCalendarAlt />
                                        <span>{t('dates')}</span>
                                    </p>
                                    <div>
                                        {hall.bookDate&& new Date(hall.bookDate).toLocaleDateString("en-GB")}
                                        <p>{hall.duration===1?t("morning-period"):t("afternoon-period")}</p>
                                    </div>
                                    
                                </div>

                              
                            </div>
                        </Link>
                    ))}
                   
                </div>

            )}
        </>
    )
}

export default BookedHalls

